<template>
    <Paper class="p-4">
        <div class="d-flex align-items-center pointer" @click="onHeaderClick">
            <BaseIcon
                class="chevron-icon mr-2"
                :class="{ rotate: open }"
                style="color: var(--cute-color) !important"
                name="chevron-right"
                size="sm"
            />
            <h4
                class="title font-weight-bold mb-0 noselect"
                :style="activeColor"
            >
                {{ title }}
            </h4>
        </div>

        <b-collapse :visible="open" :id="`testItem-${title}`">
            <div class="d-flex align-items-center mt-3">
                <BaseButton
                    v-if="videoLink"
                    class="action-btn mr-3 d-flex align-items-center"
                    tiny
                    extended
                    variant="outline-dark"
                    @click="openVideo"
                >
                    <BaseIcon class="mr-1" name="video" size="xs" />
                    {{ $t('tests.cute.watchVideo') }}
                </BaseButton>
                <BaseButton
                    class="action-btn mr-3 d-flex align-items-center"
                    tiny
                    extended
                    variant="outline-dark"
                    @click="openTest"
                >
                    <BaseIcon class="mr-1" name="play" size="xs" />
                    {{ $t('tests.cute.startTest') }}
                </BaseButton>
            </div>
            <h4 class="caption font-weight-bold mt-4">
                {{ $t('tests.cute.measurementTitle') }}
            </h4>
            <h4 class="caption mb-4">{{ measurement }}</h4>
            <h4 class="caption font-weight-bold">
                {{ $t('tests.cute.taskTitle') }}
            </h4>
            <h4 class="caption mb-4">{{ task }}</h4>
            <h4 class="caption font-weight-bold">
                {{ $t('tests.cute.durationTitle') }}
            </h4>
            <h4 v-if="testTime" class="caption">
                {{ $t('tests.cute.testTime', { minutes: testTime }) }}
            </h4>
            <h4 v-if="fullTestTime" class="caption">
                {{ $t('tests.cute.fullTestTime', { minutes: testTime }) }}
            </h4>
        </b-collapse>
    </Paper>
</template>

<script>
export default {
    name: 'TestItem',
    props: {
        id: {
            type: Number,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        measurement: {
            type: String,
            required: true,
        },
        task: {
            type: String,
            required: true,
        },
        testTime: [Number, String], // In minutes
        fullTestTime: [Number, String], // In minutes,
        videoLink: String,

        open: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        activeColor() {
            return `color:${(this.open ? 'var(--cute-color)' : 'var(--gray)') +
                '!important'}`;
        },
    },
    methods: {
        onHeaderClick() {
            this.$emit('click', this.id);
        },
        openTest() {
            this.$emit('open-test');
        },
        openVideo() {
            if (this.videoLink) {
                window.open(this.videoLink, '_blank');
            }
        },
    },
};
</script>

<style scoped>
.chevron-icon {
    transition-duration: 0.3s;
}

.rotate {
    transform: rotateZ(90deg);
}

.action-btn {
    font-size: 12px !important;
}
</style>
